import React from 'react';
import { FiSave, FiEdit2, FiTrash2, FiRotateCcw } from 'react-icons/fi';

import Button from '../../Atoms/Button';

import { Container, Hint } from './styles';

interface FormActionsProps {
  /** `true` quando há um item selecionado (modo edição). */
  editing: boolean;
  /** `true` quando há alterações não salvas. */
  dirty: boolean;
  saving?: boolean;
  deleting?: boolean;
  /** Desabilita Excluir (ex.: tipo sem endpoint de exclusão). */
  canDelete?: boolean;
  onSave: () => void;
  onEdit: () => void;
  onDelete: () => void;
  onClear: () => void;
}

/**
 * Barra de ações fixa do editor de conteúdo. A ordem é sempre a mesma em todas
 * as telas: Salvar · Editar · Excluir · Limpar.
 */const FormActions: React.FC<FormActionsProps> = ({
  editing,
  dirty,
  saving = false,
  deleting = false,
  canDelete = true,
  onSave,
  onEdit,
  onDelete,
  onClear,
}) => {
  const busy = saving || deleting;

  return (
    <Container>
      <Button type="button" onClick={onSave} loading={saving} disabled={busy}>
        <FiSave aria-hidden />
        {editing ? 'Salvar alterações' : 'Salvar'}
      </Button>

      <Button
        type="button"
        contrast
        onClick={onEdit}
        disabled={!editing || !dirty || busy}
      >
        <FiEdit2 aria-hidden />
        Editar
      </Button>

      <Button
        type="button"
        state="danger"
        onClick={onDelete}
        loading={deleting}
        disabled={!editing || !canDelete || busy}
      >
        <FiTrash2 aria-hidden />
        Excluir
      </Button>

      <Button type="button" contrast onClick={onClear} disabled={busy}>
        <FiRotateCcw aria-hidden />
        Limpar
      </Button>

      <Hint>
        {editing
          ? dirty
            ? 'Alterações não salvas.'
            : 'Editando um item existente.'
          : 'Novo item — preencha e salve.'}
      </Hint>
    </Container>
  );
};

export default FormActions;
